import React, { useEffect } from "react";

import { DatePickerWithInput } from "Components/molecules/DatePickerWithInput/Desktop";
import { FieldSearch } from "../styles";
// @ts-ignore
import { ReactComponent as CalendarGoingSvg } from "assets/svgs/calendar-going.svg";
import { useCalendarContext } from "shared/contexts/CalendarContext";
import { useSearchContext } from "shared/contexts/SearchContext";
import { orderDatesAsc } from "shared/utils/dates";

/**
 * Componente DataSearchDestinationDesktop
 *
 * Configuração para datas de destino no layout Desktop.
 */
export const DataSearchDestinationDesktop: React.FC = () => {
  const { daysInMonth, selectedDestinationDates, setSelectedDestinationDates } =
    useCalendarContext();
  const { setReturnDates } = useSearchContext();
  const { searchState } = useSearchContext();

  const handleSetDepartureDates = (dates: string[]) => {
    const newDates = orderDatesAsc(dates);
    setSelectedDestinationDates(newDates);
    setReturnDates(newDates);
  };

  useEffect(() => {
    setSelectedDestinationDates(searchState?.returnDates ?? []);
    setReturnDates(searchState?.returnDates ?? []);
  }, [searchState.returnDates]);

  const isDisabled = searchState.tripType === "oneWay";
  return (
    <FieldSearch className={isDisabled ? "disabled" : ""}>
      <CalendarGoingSvg />
      <DatePickerWithInput
        title="Selecione até 4 datas de volta"
        placeholder="Volta"
        maxSelectableDates={4}
        daysInMonth={daysInMonth}
        selectedDates={selectedDestinationDates}
        onDatesChange={handleSetDepartureDates}
        type="destination"
        isDisabled={isDisabled}
      />
    </FieldSearch>
  );
};
